import { TFunction } from 'i18next';

export const getScheduleButtonText = (
  t: TFunction,
  isOptimizing: boolean | null = false,
  isPublished: boolean = false): string => {

  if (isPublished) {
    return t('unscheduledVisits.scheduleWarningModal.confirmPublish');
  }
  return t(`unscheduledVisits.scheduleWarningModal.${isOptimizing ? 'scheduling' : 'confirm'}`);
};
